import { StoryModel } from 'types/story';
import { GET_STORY } from 'admin/constants/actions';
import { getStory as getStoryEndpoint } from 'admin/resources';
import { filterStoryVersions } from 'common/utils/facades/story-facade';
import { RouteComponentProps } from 'react-router-dom';
import { NOT_FOUND } from 'admin/constants/routes';
import { createThunkAction } from 'admin/actions/helpers';

const IS_FILTER_VERSIONS = false;

interface GetStoryParams {
	storyId: string;
	history?: RouteComponentProps['history'];
}

/**
 * Get story by id
 */
export const getStory = createThunkAction<StoryModel, GetStoryParams>({
	type: GET_STORY,
	payloadCreator: async params => {
		const response = await getStoryEndpoint.params({ storyId: params.storyId }).send();
		const story: StoryModel = response.body.result;

		const filteredStory = IS_FILTER_VERSIONS && story ? filterStoryVersions(story) : story;

		return { ...response.body, result: filteredStory };
	},
	onError: ({ params, error }) => {
		if (error?.status === 404 && params.history) params.history.push(NOT_FOUND);
	},
});
